import type { AxiosResponse } from 'axios';
import { callGetApi, callPostApi } from '@/src/core/utils/api';
import { IContactUs } from '@/types/misc';

/**
 * API Endpoint for Contact Us  requirements
 */
export const contactUs = async (data: IContactUs) => {
  try {
    const response: AxiosResponse<{
      result: boolean;
      errors: boolean;
    }> = await callPostApi('/landing/contact-us', data);
    return response.data.result;
  } catch (e) {
    console.log('Contact Us Error: ' + e);
    return false;
  }
};

export const getLocationZipcodes = async (
  region_name: string,
  city_name: string
) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callGetApi('/v1/location/zipcodes-list', {
      region_name,
      city_name,
    });
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const generateVoiceOver = async (text: string) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callPostApi('/v1/services/voice/public/generate-from-text', {
      text,
    });
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const getAiMarketUpdate = async (
  persona_type: string,
  region: string,
  city: string,
  zipcode: string,
  zone_id?: string
) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callPostApi(
      '/v1/landing/content-factory/generate-market-update',
      {
        persona_type,
        region,
        city,
        zipcode,
        zone_id,
      }
    );
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const getNewsContents = async (
  region: string,
  city: string,
  zipcode: string,
  zone_id?: string
) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callPostApi('/v1/landing/content-factory/news-list', {
      region,
      city,
      zipcode,
      zone_id,
    });
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const getCommunityContents = async (
  region: string,
  city: string,
  zipcode: string,
  zone_id?: string
) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callPostApi('/v1/landing/content-factory/generate-community', {
      region,
      city,
      zipcode,
      zone_id,
    });
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const getContentFactoryListings = async (
  listing_id: string,
  zone_id?: string
) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callPostApi('/v1/landing/content-factory/listing', {
      listing_id,
      zone_id,
    });
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const setContentFactoryInCache = async (
  email: string,
  type: string,
  content: object,
  branding: object,
  location: object,
  voice: object,
  template?: number,
  font?: number
) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callPostApi(
      '/v1/landing/content-factory/save-selected-content',
      {
        email,
        type,
        content,
        branding,
        location,
        voice,
        template,
        font,
      }
    );
    return response.data.data;
  } catch (e) {
    throw e;
  }
};
export const getContentFactoryFromCache = async (email: string) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callGetApi('/v1/landing/content-factory/get-selected-content', {
      email,
    });
    return response.data.data;
  } catch (e) {
    throw e;
  }
};

export const userCanDownload = async (email: string) => {
  try {
    const response: AxiosResponse<{
      data: any;
      message: string;
      status: string;
    }> = await callGetApi('/v1/landing/content-factory/user-can-download', {
      email,
    });
    return response.data.data.can_download;
  } catch (e) {
    return false;
  }
};
